<script>
export default {
  components: {},
};
</script>

<template>
  <div class="ecu-auth">
    <div class="account-pages ecu-auth__inner">
      <div class="container">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
/* ==========================================================================
   ECU auth theme - shared by Login, Staff Login, Forgot / Set / Reset Password.
   Everything is namespaced `eauth-*`. The page background is plain white; all
   decoration lives inside the dialog card.
   ========================================================================== */
$art-split: url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 1258 749%22 preserveAspectRatio=%22none%22%3E %3Cdefs%3E %3ClinearGradient id=%22r%22 x1=%220%22 y1=%220%22 x2=%220%22 y2=%221%22%3E%3Cstop offset=%220%22 stop-color=%22%23ffd2a8%22 stop-opacity=%22.55%22/%3E%3Cstop offset=%221%22 stop-color=%22%23ffe2c8%22 stop-opacity=%22.12%22/%3E%3C/linearGradient%3E %3ClinearGradient id=%22w1%22 x1=%220%22 y1=%220%22 x2=%220%22 y2=%221%22%3E%3Cstop offset=%220%22 stop-color=%22%23ffeedd%22 stop-opacity=%22.9%22/%3E%3Cstop offset=%221%22 stop-color=%22%23ffdfc0%22 stop-opacity=%22.95%22/%3E%3C/linearGradient%3E %3ClinearGradient id=%22w2%22 x1=%220%22 y1=%220%22 x2=%221%22 y2=%220%22%3E%3Cstop offset=%220%22 stop-color=%22%23ffd7b0%22 stop-opacity=%22.25%22/%3E%3Cstop offset=%22.5%22 stop-color=%22%23ffd0a0%22 stop-opacity=%22.5%22/%3E%3Cstop offset=%221%22 stop-color=%22%23ffd7b0%22 stop-opacity=%22.3%22/%3E%3C/linearGradient%3E %3C/defs%3E %3Cpath d=%22M822 0 C760 60 700 170 697 270 C695 350 745 400 743 490 C741 580 690 660 610 725 L600 749 L1258 749 L1258 0 Z%22 fill=%22%23fef9f5%22/%3E %3Cpath d=%22M822 0 C760 60 700 170 697 270 L699 300 C715 180 800 60 912 0 Z%22 fill=%22url(%23r)%22/%3E %3Cpath d=%22M850 0 C780 55 714 160 698 255 L700 288 C722 175 810 70 912 0 Z%22 fill=%22%23ffc08a%22 fill-opacity=%22.28%22/%3E %3Cpath d=%22M0 655 C120 630 250 650 380 690 C500 725 600 745 700 735 C850 722 1050 640 1258 648 L1258 749 L0 749 Z%22 fill=%22url(%23w1)%22/%3E %3Cpath d=%22M0 702 C150 690 330 740 520 749 L0 749 Z%22 fill=%22%23ffd9b5%22 fill-opacity=%22.45%22/%3E %3Cpath d=%22M560 749 C800 742 1000 690 1258 692 L1258 749 Z%22 fill=%22url(%23w2)%22/%3E %3C/svg%3E");
$art-swoosh: url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%22640 0 535 335%22 preserveAspectRatio=%22none%22%3E %3Cdefs%3E %3ClinearGradient id=%22w%22 x1=%220%22 y1=%221%22 x2=%221%22 y2=%220%22%3E%3Cstop offset=%220%22 stop-color=%22%23fff5ec%22 stop-opacity=%22.05%22/%3E%3Cstop offset=%22.5%22 stop-color=%22%23ffead9%22 stop-opacity=%22.28%22/%3E%3Cstop offset=%221%22 stop-color=%22%23ffe3cd%22 stop-opacity=%22.34%22/%3E%3C/linearGradient%3E %3ClinearGradient id=%22r%22 x1=%220%22 y1=%221%22 x2=%221%22 y2=%220%22%3E%3Cstop offset=%220%22 stop-color=%22%23ffeddd%22 stop-opacity=%22.10%22/%3E%3Cstop offset=%22.6%22 stop-color=%22%23ffdab9%22 stop-opacity=%22.32%22/%3E%3Cstop offset=%221%22 stop-color=%22%23ffd5ad%22 stop-opacity=%22.36%22/%3E%3C/linearGradient%3E %3C/defs%3E %3Cpath d=%22M650 0 C760 15 880 60 980 120 C1060 168 1120 205 1175 245 L1175 0 Z%22 fill=%22url(%23w)%22/%3E %3Cpath d=%22M650 0 C780 10 900 60 1010 140 C1080 190 1130 225 1175 250 L1175 238 C1120 205 1060 165 985 118 C880 55 760 12 650 0 Z%22 fill=%22%23ffe8d3%22 fill-opacity=%22.30%22/%3E %3Cpath d=%22M770 0 C880 20 980 80 1060 150 C1110 195 1150 225 1175 238 L1175 0 Z%22 fill=%22url(%23r)%22/%3E %3C/svg%3E");

.ecu-auth {
  --ecu-orange: #f97316;
  --ecu-orange-dark: #e84d00;
  --ecu-navy: #0b1f4b;
  --ecu-muted: #5f6579;
  --ecu-border: #e3e5ee;

  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
  background: #fff;
  font-family: "Inter", "Plus Jakarta Sans", "Segoe UI", system-ui, -apple-system,
    sans-serif;
  -webkit-text-size-adjust: 100%;

  &__inner {
    width: 100%;
  }
  .container {
    padding-left: 16px;
    padding-right: 16px;
  }
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
}

.eauth-shell {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  &--wide {
    max-width: 800px;
  }
}

/* ---------- Card ---------- */
.eauth-card {
  position: relative;
  overflow: hidden;
  background: #fff;
  border-radius: 24px;
  padding: 32px 36px 36px;
  border: 1px solid #f1f1f6;
  box-shadow: 0 18px 50px -18px rgba(17, 24, 39, 0.2),
    0 2px 8px rgba(17, 24, 39, 0.04);

  /* decorative swoosh (top-right) - one design, shared by every auth card */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    aspect-ratio: 535 / 335;
    background-image: $art-swoosh;
    background-repeat: no-repeat;
    background-position: top right;
    background-size: 100% 100%;
    pointer-events: none;
  }

  &--split {
    display: grid;
    /* left column ends before the curve in the art (~55% of the card);
       the illustration lives right of it */
    grid-template-columns: 53% minmax(0, 1fr);
    gap: 0;
    align-items: center;
    min-height: 440px;
    padding-bottom: 52px;
    > :first-child {
      align-self: start;
    }
    &::before {
      inset: 0;
      width: 100%;
      height: 100%;
      background-image: $art-split;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
    }
  }

  > * {
    position: relative;
    z-index: 1;
  }
}

.eauth-illustration-wrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.eauth-illustration {
  width: 260px;
  max-width: 100%;
  height: auto;
}

/* ---------- Typography ---------- */
.eauth-logo {
  display: block;
  height: 58px;
  width: auto;
  max-width: 100%;
  margin-bottom: 18px;
  mix-blend-mode: multiply;
}
.eauth-accent {
  width: 46px;
  height: 5px;
  border-radius: 5px;
  margin-bottom: 16px;
  background: linear-gradient(90deg, #ff8a00, #ffc46b);
}
.eauth-title {
  margin: 0 0 8px;
  font-size: var(--ecu-fs-h1);
  font-weight: var(--ecu-fw-heading);
  line-height: 1.18;
  letter-spacing: -0.02em;
  color: var(--ecu-navy);
}
.eauth-sub {
  margin: 0 0 20px;
  font-size: var(--ecu-fs-body);
  line-height: 1.5;
  color: var(--ecu-muted);
}

/* ---------- Fields ----------
   The wrapper draws the border / radius; the input inside is borderless.
   (custom.css has a global `input:not([type=radio]...)` rule that sets
   padding + square corners, so the input rules below out-rank it.) */
.eauth-group {
  margin-bottom: 14px;
}
.eauth-label {
  display: block;
  margin-bottom: 6px;
  font-size: var(--ecu-fs-body);
  font-weight: var(--ecu-fw-normal);
  color: var(--ecu-navy);
}
.eauth-field {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 46px;
  padding: 0 14px;
  background: #fff;
  border: 1.5px solid var(--ecu-border);
  border-radius: 16px;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;

  &:focus-within {
    border-color: #ff8a1f;
    box-shadow: 0 0 0 4px rgba(255, 138, 31, 0.15);
  }
  &.is-invalid {
    border-color: #e5484d;
    &:focus-within {
      box-shadow: 0 0 0 4px rgba(229, 72, 77, 0.14);
    }
  }
  &--disabled {
    background: #f6f6fa;
  }

  .eauth-field__icon {
    flex: 0 0 auto;
    font-size: 20px;
    line-height: 1;
    color: #7b8194;
  }
  input.eauth-input {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0 !important;
    font-size: var(--ecu-fs-body);
    color: var(--ecu-navy);
    background: transparent;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    outline: 0;
    -webkit-appearance: none;
    appearance: none;

    &::placeholder {
      color: #8b90a3;
      opacity: 1;
    }
    &:disabled {
      color: #6b7186;
      cursor: not-allowed;
    }
    &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 40px #fff inset !important;
      -webkit-text-fill-color: var(--ecu-navy);
    }
  }
}
.eauth-field__toggle {
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  margin-right: -6px;
  display: grid;
  place-items: center;
  font-size: 18px;
  color: #7b8194;
  background: none;
  border: 0;
  border-radius: 10px;
  cursor: pointer;
  &:hover {
    color: var(--ecu-orange);
  }
}
.eauth-error {
  margin-top: 5px;
  font-size: var(--ecu-fs-small);
  color: #d92d20;
}
.eauth-link {
  padding: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: #e8590c;
  background: none;
  border: 0;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    color: var(--ecu-orange-dark);
    text-decoration: underline;
  }
}
.eauth-row-end {
  display: flex;
  justify-content: flex-end;
  margin-top: 6px;
}

/* ---------- Buttons ---------- */
.eauth-btn {
  height: 46px;
  padding: 0 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  border: 0;
  border-radius: 16px;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.15s, box-shadow 0.2s, opacity 0.2s;

  i {
    font-size: 19px;
    line-height: 1;
  }
  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
  &--block {
    width: 100%;
  }
  &--primary {
    color: #fff;
    background: linear-gradient(180deg, #ff8a00 0%, var(--ecu-orange-dark) 100%);
    box-shadow: 0 12px 22px -12px rgba(232, 77, 0, 0.7);
    &:hover:not(:disabled) {
      color: #fff;
      transform: translateY(-1px);
      box-shadow: 0 16px 26px -12px rgba(232, 77, 0, 0.75);
    }
  }
  &--ghost {
    color: var(--ecu-navy);
    background: linear-gradient(180deg, #fffaf4, #fff1e2);
    border: 1.5px solid #ffc999;
    &:hover:not(:disabled) {
      color: var(--ecu-navy);
      background: #ffeedd;
    }
  }
}
.eauth-actions {
  display: flex;
  gap: 14px;
  margin-top: 22px;

  .eauth-btn--ghost {
    flex: 0 0 34%;
  }
  .eauth-btn--primary {
    flex: 1 1 auto;
    min-width: 0;
  }
}

/* ---------- Choice rows (Get Started) ---------- */
.eauth-option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  text-align: left;
  background: #fff;
  border: 1.5px solid #e6e7f0;
  border-radius: 16px;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.2s, border-color 0.2s;

  &:hover {
    transform: translateY(-1px);
    border-color: #ffc999;
    box-shadow: 0 12px 22px -16px rgba(249, 115, 22, 0.6);
  }
  &--accent {
    background: #fff3e6;
    border-color: #ffd9b3;
  }
  &__icon {
    flex: 0 0 52px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    padding-right: 12px;
    border-right: 1px solid #e3e5ee;
    font-size: 28px;
    color: var(--ecu-navy);
    img {
      height: 26px;
      width: auto;
    }
  }
  &__text {
    flex: 1 1 auto;
    min-width: 0;
    h4 {
      margin: 0;
      font-size: 1rem;
      font-weight: 700;
      color: var(--ecu-navy);
    }
    p {
      margin: 3px 0 0;
      font-size: 0.8rem;
      color: var(--ecu-muted);
    }
  }
  &__arrow {
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    display: grid;
    place-items: center;
    font-size: 19px;
    color: var(--ecu-navy);
    background: #eff0f8;
    border-radius: 50%;
  }
  &--accent &__arrow {
    color: var(--ecu-orange);
    background: #ffe3c8;
  }
}
.eauth-or {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 12px 0;
  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #dcdef0;
  }
  span {
    padding: 4px 18px;
    font-size: 0.85rem;
    font-weight: 700;
    color: var(--ecu-orange);
    background: #fff0e0;
    border-radius: 999px;
  }
}

/* ---------- Alerts / status ---------- */
.eauth-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;
  padding: 10px 12px;
  font-size: 0.85rem;
  font-weight: 600;
  border-radius: 12px;
  i {
    font-size: 18px;
    line-height: 1.2;
  }
  &--error {
    color: #b42318;
    background: #fef3f2;
    border: 1px solid #fecdca;
  }
  &--success {
    color: #067647;
    background: #ecfdf3;
    border: 1px solid #abefc6;
  }
}
.eauth-status {
  text-align: center;
  padding: 4px 0 0;
  &__icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 14px;
    display: grid;
    place-items: center;
    font-size: 32px;
    color: #fff;
    border-radius: 50%;
    background: linear-gradient(180deg, #ff8a00, var(--ecu-orange-dark));
    box-shadow: 0 12px 22px -12px rgba(232, 77, 0, 0.7);
  }
}

/* ---------- Footer ---------- */
.eauth-footer {
  margin-top: 20px;
  text-align: center;
  font-size: var(--ecu-fs-body);
  color: #555b6e;
  p {
    margin: 0;
  }
  a {
    font-weight: 600;
    color: var(--ecu-orange);
  }
}

/* ==========================================================================
   Responsive
   ========================================================================== */
@media (max-width: 991px) {
  .eauth-shell--wide {
    max-width: 700px;
  }
  .eauth-illustration {
    width: 220px;
  }
}

/* tablet portrait / large phones: single column, illustration hidden */
@media (max-width: 767px) {
  .eauth-shell,
  .eauth-shell--wide {
    max-width: 480px;
  }
  .eauth-card--split {
    display: block;
    min-height: 0;
    padding-bottom: 36px;
    &::before {
      inset: auto;
      top: 0;
      right: 0;
      width: 50%;
      height: auto;
      aspect-ratio: 535 / 335;
      background-image: $art-swoosh;
    background-repeat: no-repeat;
    background-position: top right;
    background-size: 100% 100%;
    }
  }
  .eauth-illustration-wrap {
    display: none;
  }
}

@media (max-width: 575px) {
  /* Vertically centre the card between top and bottom of the screen.
     border-box keeps min-height: 100dvh + padding from causing a scrollbar;
     the env() insets keep it clear of notches / home bars. */
  .ecu-auth {
    box-sizing: border-box;
    align-items: center;
    padding: max(16px, env(safe-area-inset-top)) 0
      max(16px, env(safe-area-inset-bottom));
  }
  .eauth-card {
    padding: 24px 20px 28px;
    border-radius: 20px;
  }
  /* Logo: centred, 15% larger than before (50px -> 57.5px) */
  .eauth-logo {
    height: 57.5px;
    margin: 0 auto 14px;
  }
  /* Heading block follows the centred logo (labels / inputs stay left) */
  .eauth-accent {
    margin-left: auto;
    margin-right: auto;
  }
  .eauth-title,
  .eauth-sub {
    text-align: center;
  }
  .eauth-title {
    font-size: var(--ecu-fs-h1-sm);
  }
  .eauth-sub {
    margin-bottom: 16px;
  }
  .eauth-footer {
    margin-top: 16px;
    font-size: var(--ecu-fs-small);
  }
}

/* very small phones: stack the action buttons, primary first */
@media (max-width: 400px) {
  .eauth-card {
    padding: 22px 16px 24px;
  }
  /* Back + primary button stay on ONE row, even on the smallest phones */
  .eauth-actions {
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 10px;
    .eauth-btn {
      height: 44px;
      padding: 0 12px;
      gap: 6px;
      font-size: 0.9rem;
    }
    .eauth-btn--ghost {
      flex: 0 0 auto;
      width: auto;
    }
    .eauth-btn--primary {
      flex: 1 1 0;
      min-width: 0;
    }
  }
  .eauth-option {
    padding: 12px;
    gap: 10px;
    &__icon {
      flex-basis: 40px;
      padding-right: 10px;
      font-size: 24px;
    }
    &__arrow {
      flex-basis: 30px;
      width: 30px;
      height: 30px;
      font-size: 16px;
    }
  }
}

/* short landscape screens */
@media (max-height: 520px) and (orientation: landscape) {
  .ecu-auth {
    align-items: flex-start;
  }
}
</style>